<template>
  <slot name="key" />
  <slot name="values" />
</template>
